// extracted by css-extract-rspack-plugin
export default {"Link":"nQFv1"};